import { api } from '../api';

const userApi = api.injectEndpoints({
    endpoints: (build) => ({
        getUserView: build.query({
            query: (payload) => ({
                url: '/user/view',
                method: 'GET',
                params: payload
            })
        })
    }),
});


export const { useLazyGetUserViewQuery} = userApi;
